import clsx from 'clsx';
import React from 'react';
import { Icon, SemanticCOLORS } from 'semantic-ui-react';
import { PosIconsId } from '../../types/PosIcons';

export type POSICons = PosIconsId;

export interface Props {
  className?: string;
  icon: POSICons;
  color?: SemanticCOLORS;
  onClick?: () => void;
}

export const POSIcon = (props: Props) => {
  return (
    <Icon
      className={clsx(`pos ${props.icon}`, props.className)}
      color={props.color}
      onClick={props.onClick}
    />
  );
};
